var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import Select from "@frameworks/NCD/Components/Select";
var TimeSlotPicker = function (_a) {
    var indexV = _a.indexV;
    var _b = __read(useState(false), 2), open = _b[0], setOpen = _b[1];
    var partnerSelectedSlot = useSelector(function (state) { return state.markets.leadservice; }).partnerSelectedSlot;
    var _c = __read(useState(indexV || 0), 2), indexValue = _c[0], setValue = _c[1];
    var nextDays = Array.from({ length: 7 }, function (_, index) { return ({
        label: moment()
            .add(index + indexValue, "days")
            .format("YYYY-MM-DD"),
        value: moment()
            .add(index + indexValue, "days")
            .format("YYYY-MM-DD"),
    }); });
    var generateTimeSlots = function () {
        var customSlots = [
            { startHour: 9, endHour: 12, centerHour: "11" },
            { startHour: 13, endHour: 17, centerHour: "4" },
            { startHour: 17, endHour: 19, centerHour: "6" },
        ];
        return customSlots.map(function (_a) {
            var startHour = _a.startHour, endHour = _a.endHour, centerHour = _a.centerHour;
            var start = moment().startOf("day").add(startHour, "hours");
            var end = moment().startOf("day").add(endHour, "hours");
            return {
                label: "".concat(start.format("h A"), " - ").concat(end.format("h A")),
                value: "".concat(start.format("H"), "-").concat(end.format("H")),
            };
        });
    };
    var _d = __read(useState(generateTimeSlots()), 2), availableSlots = _d[0], setAvailableSlots = _d[1];
    var _e = __read(useState(""), 2), selectedTimeSlot = _e[0], setSelectedTimeSlot = _e[1];
    var updateAvailableSlots = function (date) {
        var updatedSlots = generateTimeSlots();
        setAvailableSlots(updatedSlots);
    };
    var handleSelectDate = useCallback(function (date) {
        updateAvailableSlots(date);
    }, []);
    var handleSelectTimeSlot = function (item) {
        setSelectedTimeSlot(item.value);
        aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { timeSlot: item.label }));
    };
    useEffect(function () {
        if (partnerSelectedSlot.date) {
            updateAvailableSlots(partnerSelectedSlot.date);
        }
        else {
            updateAvailableSlots(moment().format("YYYY-MM-DD"));
        }
    }, [partnerSelectedSlot.date]);
    useEffect(function () {
        var selectedDate = moment(partnerSelectedSlot.date).format("YYYY-MM-DD");
        var futureSlots = availableSlots.filter(function (item) {
            var slotStartTime = moment("".concat(selectedDate, " ").concat(Number(item.value.split("-")[1]) - 1), "YYYY-MM-DD H");
            return !moment().isAfter(slotStartTime);
        });
        if (futureSlots.length > 0) {
            setSelectedTimeSlot(futureSlots[0].value);
            aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { timeSlot: futureSlots[0].label }));
        }
        else {
            setValue(1);
            setSelectedTimeSlot("");
        }
    }, [availableSlots, partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date]);
    useEffect(function () {
        if (indexValue > 0) {
            handleSelectDate(nextDays[0].value);
            aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { date: nextDays[0].value }));
        }
    }, [indexValue]);
    var today = new Date(); // or new Date('2025-06-27') for testing
    var tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    var formatDates = function (dateArray) {
        return dateArray.map(function (item) {
            var date = moment(item.label);
            var today = moment();
            var suffix = date.format("dddd");
            if (date.isSame(today, "day")) {
                suffix = "Today";
            }
            else if (date.isSame(today.clone().add(1, "day"), "day")) {
                suffix = "Tomorrow";
            }
            var label = "".concat(date.format("DD MMM"), " \u2013 ").concat(suffix);
            return __assign(__assign({}, item), { label: label });
        });
    };
    return (React.createElement("div", { className: "top-container time-slot-picker mx-3", style: { paddingBottom: open ? "160px" : "0px" } },
        React.createElement(Select, { openLocal: open, setOpenLocal: setOpen, label: "Choose a time-slot", data: formatDates(nextDays), onSelect: function (item) {
                handleSelectDate(item === null || item === void 0 ? void 0 : item.value);
                aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { date: item === null || item === void 0 ? void 0 : item.value }));
            } }),
        React.createElement("div", { className: "time-slots mt-2" }, availableSlots.map(function (item, index) {
            var selectedDate = moment(partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date).format("YYYY-MM-DD");
            var slotStartTime = moment("".concat(selectedDate, " ").concat(Number(item.value.split("-")[1]) - 1), "YYYY-MM-DD H");
            var isPast = moment().isAfter(slotStartTime);
            var isSelected = selectedTimeSlot === item.value;
            var isBooked = partnerSelectedSlot.timeSlot === item.value;
            return (React.createElement("button", { type: "button", key: index.toString(), className: "time-slot DMSanN_12_400 mb-1 ".concat(isPast
                    ? "disabled"
                    : isSelected || isBooked
                        ? "selected"
                        : "available-slot"), onClick: function () {
                    handleSelectTimeSlot(item);
                }, disabled: isPast || isBooked }, item.label));
        }))));
};
export default TimeSlotPicker;
